import React from "react"
import Layout from "../modules/Layout"
import BodyBlocks from "../technical/BodyBlocks"
import BlockWrapper from "../technical/BlockWrapper"

import Link from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Link"
import Seo from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Seo"

import NewsHeader from "../blocks/NewsHeader"
import { ChevronRight20 } from "@carbon/icons-react"

import TextBlock from "../blocks/TextBlock"

const NewsPage = ({ content, language, breadcrumbs }) => {
  let seoImage = null

  if (
    !content.image?.filename &&
    content.body &&
    content.body[0] &&
    content.body[0].image &&
    content.body[0].image.filename
  ) {
    seoImage = content.body[0].image.filename
  } else {
    seoImage = content.image?.filename
  }

  return (
    <Layout language={language}>
      <Seo title={content.headline} content={content} og_image={seoImage} />
      <BlockWrapper block={{}} blockPadding="pt-4 pb-2">
        <div className="text-lg font-bold tracking-widest uppercase">
          {breadcrumbs?.slice(0, 2).map((breadcrumb, index) => (
            <span key={breadcrumb.link}>
              {index > 0 && (
                <ChevronRight20 className="inline-block w-10 h-10 pr-4 -mt-0.5" />
              )}
              <Link
                className={`pr-4 hover:underline ${
                  index === breadcrumbs.length - 1 ? "text-primary" : ""
                }`}
                key={index}
                link={breadcrumb.link}
              >
                {breadcrumb.link_text}
              </Link>
            </span>
          ))}
        </div>
      </BlockWrapper>
      <NewsHeader
        block={{
          kicker: content.kicker,
          headline: content.title,
          image: content.image,
          show_square: content.show_square,
        }}
      />
      <div className="-mb-8"></div>
      <TextBlock
        block={{
          flow: content.flow,
          align_left: content.align_left,
          text: content.teaser,
          block_bg: "bg-gray-50",
        }}
      />
      <BodyBlocks body={content.body} />
    </Layout>
  )
}

export default NewsPage
